import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';

import { Error } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';
import { TiposDocumento } from '@rpe/registro-personas-empresas-lib/src/lib/tipos-documento/tipos-documento.model';

export const entityTiposDocumentoAdapter: EntityAdapter<TiposDocumento> =
  createEntityAdapter<TiposDocumento>({
    selectId: (model) => model.codigo,
    sortComparer: (a: TiposDocumento, b: TiposDocumento): number =>
      a.nombre.toString().localeCompare(b.nombre.toString())
  });

export interface EntityTiposDocumentoState extends EntityState<TiposDocumento> {
  isLoading?: boolean;
  error?: Error | null;
}

export const initialState: EntityTiposDocumentoState =
  entityTiposDocumentoAdapter.getInitialState({
    isLoading: false,
    error: null
  });
